module.exports = __webpack_public_path__ + "assets/img/natrium-1.c048d6393d0d66d9610d4e0ef076b505.png";